// /src/components/formbuilder/admin/utils/FieldEditorRegistry.js

// ====================================================================
// 🧩 Champs de saisie
// ====================================================================
import { EditTextField } from "./../controls/text";

import { EditTextareaField } from "./../controls/textarea";

import { EditEmailField } from "./../controls/email";

import { EditNumberField } from "./../controls/number";

import { EditTelField } from "./../controls/tel";
import { EditUrlField } from "./../controls/url";

// ====================================================================
// 🧠 Choix / sélection
// ====================================================================
import { EditSelectField } from "./../controls/select";
import { EditSelectMultipleField } from "./../controls/selectMultiple";
import { EditCheckboxField } from "./../controls/checkbox";
import { EditRadioField } from "./../controls/radio";




// ====================================================================
// 📅 Date / heure
// ====================================================================
import { EditDateField } from "./../controls/date";

import { EditDatetimeField } from "./../controls/datetime";

// ====================================================================
// 📁 Fichier / data
// ====================================================================
import { EditFileField } from "./../controls/file";

// ====================================================================
// 🧱 Contenu statique
// ====================================================================
import { EditStaticTitleField } from "./../controls/staticTitle";
import { EditStaticTextField } from "./../controls/staticText";
import { EditSeparatorField } from "./../controls/separator";


// ====================================================================
// ⚙️ Champs complexes / métiers
// ====================================================================

import { EditPersonField } from "./../controls/person";
import { EditAddressField } from "./../controls/address";
import { EditCompanyField } from "./../controls/company";
/*
import { EditIdentityField } from "./../controls/identity";

import { EditPersonField } from "./../controls/person";

import { EditRibField } from "./../controls/rib";
*/

// ====================================================================
// 🧭 REGISTRY PRINCIPAL
// ====================================================================

const registry = {
  // Champs de saisie simples
  text: EditTextField,

  textarea: EditTextareaField,

  email: EditEmailField,

  number: EditNumberField,

  tel: EditTelField,
  url: EditUrlField,

  // Sélection / choix
  select: EditSelectField,
  selectMultiple: EditSelectMultipleField,
  checkbox: EditCheckboxField,
  radio: EditRadioField,
  // Date / heure
  date: EditDateField,
  datetime: EditDatetimeField,
  // Fichiers / data
  file: EditFileField,
  // Contenus statiques
  staticTitle: EditStaticTitleField,
  staticText: EditStaticTextField,
  separator: EditSeparatorField,
  /*
  divider: EditDividerField,
  textBlock: EditTextBlockField,
*/
  // Champs métiers
  person: EditPersonField,
  address: EditAddressField,
  company: EditCompanyField,
  /*
identity: EditIdentityField,



rib: EditRibField,
*/
};

// ====================================================================
// ⚙️ UTILITAIRES
// ====================================================================

export function registerCustomEditors(customEditors = {}) {
  Object.assign(registry, customEditors);
}

/**
 * Résolution de l’éditeur à partir du champ JSON Schema
 * (priorité à x-ui, fallback sur type)
 */
export function getFieldEditor(field) {




  if (!field) {
    alert("Erreur : aucun champ à éditer.");
    return null;
  }

  const ui = field["x-ui"];

  if (ui && registry[ui]) return registry[ui];

  if (!ui) {
    alert(
      `⚠️ Le champ "${field.title || field.name || "(sans nom)"}" n’a pas de propriété 'x-ui'.\n` +
      "Impossible de déterminer quel éditeur utiliser.\n" +
      "→ Ajoutez par exemple : \"x-ui\": \"text\" ou \"textarea\" dans sa définition."
    );
    return null;
  }

  if (registry[field.type]) return registry[field.type];

  alert(
    `⚠️ Aucun éditeur trouvé pour le type "${field.type}" ou l'UI "${ui}".\n` +
    "Vérifiez votre FieldEditorRegistry."
  );
  return null;
}
